import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Role, roleAsObject } from 'src/app/models';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (StorageService.userLogged) {
      return true;
    }
    this.router.navigate(['login'], {
      queryParams: {
        redirectUrl: window.location.href
      }
    });
    return false;
  }

  canActivatePermissions(permissions: Array<Role>): boolean {
    if (
      StorageService.userRolesList.some((r) =>
        permissions.map((p) => roleAsObject(p).enumValue).includes(r)
      )
    ) {
      return true;
    }
    this.router.navigate(['/unauthorized']);
    return false;
  }
}
